import { render, staticRenderFns } from "./myRecord.vue?vue&type=template&id=897ed4e0&scoped=true&"
import script from "./myRecord.vue?vue&type=script&lang=js&"
export * from "./myRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897ed4e0",
  null
  
)

export default component.exports